export enum ImageFormat {
  /**
   * @deprecated No reason to use JPEG if we can sue webp. The latter is a more efficient modern replacement and we don't care about old browsers.
   */
  JPEG = 'jpeg',
  PNG = 'png',
  WEBP = 'webp',
}

export interface ImageSize {
  width: number;
  height: number;
}

export const ARTICLE_IMAGE_RENDITIONS = {
  THUMBNAIL: { width: 300, height: Math.round((300 / 7) * 4) },
  COVER: { width: 960, height: Math.round((960 / 7) * 4) },
};

export const ARTICLE_ATTRIBUTE_IMAGE_RENDITIONS = {
  THUMBNAIL: { width: 1024, height: Math.round((1024 / 7) * 4) }, // Same thumbnail for Web and for iPad (retina)
};

export const INTEREST_IMAGE_RENDITIONS = {
  THUMBNAIL: { width: 1024, height: Math.round((1024 / 7) * 4) }, // Same thumbnail for Web and for iPad (retina)
};

export const PROFILE_IMAGE_RENDITIONS = {
  ICON: { width: 80, height: 80 },
};

export const BOOK_IMAGE_RENDITIONS = {
  THUMBNAIL: { width: 300, height: Math.round(300 * 1.6) },
  COVER: { width: 960, height: Math.round(960 * 1.6) },
};

export function getMediaUrl(mediaPath: string) {
  if (!mediaPath) {
    return undefined;
  }

  return new URL(mediaPath, window.env.REACT_APP_MEDIA_BASE_URL).toString();
}

export function generateAssetRenditionUrl(
  sourceUrl: string,
  size?: ImageSize | null,
  format: ImageFormat | null = ImageFormat.WEBP,
) {
  const url = new URL(sourceUrl);
  const path = url.pathname;
  const renditionPath = generateAssetRenditionPath(path, size, format);
  url.pathname = renditionPath;
  return url.toString();
}

export function generateAssetRenditionPath(
  sourcePath: string,
  size?: ImageSize | null,
  format?: ImageFormat | null,
): string {
  let renditionPath = sourcePath;
  if (size) {
    renditionPath = addSuffixToFilename(
      renditionPath,
      `_${size.width}x${size.height}`,
    );
  }
  switch (format) {
    case ImageFormat.JPEG:
      renditionPath = replaceExtension(renditionPath, 'jpg');
      break;
    case ImageFormat.PNG:
      renditionPath = replaceExtension(renditionPath, 'png');
      break;
    case ImageFormat.WEBP:
      renditionPath = replaceExtension(renditionPath, 'webp');
      break;
    default:
      throw new Error('Unsupported image format');
  }

  return renditionPath;
}

/**
 * Add a suffix to a filename before the extension
 * @param path
 * @param suffix
 */
export function addSuffixToFilename(path: string, suffix: string): string {
  const parts = path.split('.');
  const extension = parts.pop();
  const filename = parts.join('.');
  return `${filename}${suffix}.${extension}`;
}

/**
 * Replaces the extension of a file path with a new extension.
 * @param path
 * @param newExtension
 */
export function replaceExtension(path: string, newExtension: string): string {
  const parts = path.split('.');
  parts.pop();
  return `${parts.join('.')}.${newExtension}`;
}

export function resolveAbsoluteAppUrl(path: string): string {
  const baseUrl = window.env.REACT_APP_WEB_URL || window.location.origin;
  return `${baseUrl}${path}`;
}
